export const uk = {
    'sizes-title': 'Размеры'
};
